import React, { useContext, useEffect, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import DomainRating from "../../Placement/DomainRating";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";

function RatingSection({ domainRating, termsData }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    // Synchronize state with props when termsData changes
    if (termsData?.terms?.hidden !== undefined) {
      setIsHidden(termsData.terms.hidden);
    }
  }, [termsData?.terms?.hidden]);

  const handleToggleVisibility = async (e) => {
    const newVisibility = e.target.checked;

    setIsHidden(!newVisibility);
    const url = isHidden
      ? `/sellers/${userData?.uuid}/terms/${termsData?.terms?.uuid}/show`
      : `/sellers/${userData?.uuid}/terms/${termsData?.terms?.uuid}/hide`;
    try {
      await axiosInstance.put(url);
      toast.success(t("Visibility Updated"));
    } catch (error) {
      toast.error(t("Error updating Visibility"));
      setIsHidden(isHidden);
    }
  };

  return (
    <div id="ratingSection" className={`card card-setting ${themeStatus?.[selectedTheme]}`}>
      <div className="card-header d-flex justify-content-between">
        <h2
          className="card-title"
          style={{ fontSize: "16px", fontWeight: "700" }}
        >
          {domainRating?.domain}
        </h2>
        <label
          className="d-flex form-check form-switch"
          htmlFor="accounrSettingsPreferencesSwitch1"
        >
          <span className="me-7">
            <span className="d-block text-dark" style={{ fontSize: "16px" }}>
              {t("Website Visibility")}
            </span>
          </span>
          <span className="">
            <input
              type="checkbox"
              className="form-check-input me-0"
              style={{ width: "51px" }}
              id="accounrSettingsPreferencesSwitch1"
              checked={!isHidden}
              onChange={handleToggleVisibility}
            />
          </span>
        </label>
      </div>
      <div className="card-body pb-0 mb-3 mb-lg-5">
        <DomainRating domainRating={domainRating} flag={true} />
      </div>
    </div>
  );
}

export default RatingSection;
